import React from 'react';
import { YesNoFilter } from '~/components';

export default function ReimbursedFilter(props) {
  return <YesNoFilter icon="filter" placeholder="Reimbursed" clearable {...props} />;
}
